import { logger } from '../logger';
import { initRemoteHealthLog, appendHealthLogLine, forceFlushHealthLogs, getAllLogs } from './healthLogFile';

// Start a local (non-network) heartbeat only.
export function startHealthMonitor(intervalMs = 300000) {
  const CURRENT_KEY = 'healthLogs_current';
  const PREV_KEY = 'healthLogs_prev';
  const MAX_ENTRIES = 200;

  const safeGet = (k) => { try { return JSON.parse(localStorage.getItem(k) || '[]'); } catch { return []; } };
  const safeSet = (k, v) => { try { localStorage.setItem(k, JSON.stringify(v)); } catch {} };

  (function initStore() {
    const existing = safeGet(CURRENT_KEY);
    if (existing.length) safeSet(PREV_KEY, existing);
    const sessionStart = [{ ts: Date.now(), type: 'session-start', info: 'New app session started' }];
    safeSet(CURRENT_KEY, sessionStart);
    appendHealthLogLine('Session init ' + new Date().toISOString());
  })();

  initRemoteHealthLog();
  logger.info('[Health] in-memory logging active (no backend requests)');

  window.downloadHealthLogs = () => {
    const lines = getAllLogs();
    const text = lines.join('\n');
    const blob = new Blob([text], { type: 'text/plain' });
    const url = URL.createObjectURL(blob);
    const a = document.createElement('a');
    a.href = url;
    a.download = `health-${new Date().toISOString().replace(/[:.]/g, '-')}.log`;
    a.style.display = 'none';
    document.body.appendChild(a);
    a.click();
    document.body.removeChild(a);
    URL.revokeObjectURL(url);
  };

  const append = (entry) => {
    const list = safeGet(CURRENT_KEY);
    list.push(entry);
    if (list.length > MAX_ENTRIES) list.splice(0, list.length - MAX_ENTRIES);
    safeSet(CURRENT_KEY, list);
  };

  let timerId = null;

  const check = () => {
    const ts = Date.now();
    // Simulated heartbeat without network
    const latencyMs = 0;
    const status = 'healthy';
    const message = 'local heartbeat';
    const ok = true;
    const line = `[${new Date().toISOString()}] heartbeat status=${status} ok=${ok} latencyMs=${latencyMs} msg="${message}"`;
    logger.debug('[Health] local heartbeat');
    append({ ts, type: 'heartbeat', ok, status, message, latencyMs });
    appendHealthLogLine(line);
  };

  check(); // initial
  timerId = setInterval(check, intervalMs);

  const stop = () => {
    if (timerId) clearInterval(timerId);
    timerId = null;
    append({ ts: Date.now(), type: 'session-end', info: 'App session ending' });
    appendHealthLogLine('Session end ' + new Date().toISOString());
    forceFlushHealthLogs();
  };

  window.addEventListener('beforeunload', stop);
  return stop;
}
